import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectUnprocessedNcCount } from '../services/getProjectUnprocessedNcCount.service';

// Argument: projectId (string). Result stored under that same id in
// nonConformanceReportsSlice.unprocessedCountByProject.
export const loadProjectUnprocessedNcCount = createAsyncThunk(
  'nonConformanceReports/loadProjectUnprocessedNcCount',
  async (projectId) => {
    const response = await getProjectUnprocessedNcCount(projectId);
    return response;
  }
);
